import React from 'react';

export const Send = ({ height="32px", width="23px",padding="12px", style=''})=> (
    <svg  role='presentation' aria-label='' width={width} height={height} padding={padding} viewBox="0 0 23 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <path fill="#F2F4F5" d="M-274-336h570v671h-570z"/>
            <path fill="#0272B6" d="M22.285 17.674L1.88 31.809c-.954.67-2.067-.52-1.855-2.009l1.696-11.605 12.72-1.86c.37-.075.37-.595 0-.67l-12.72-1.86L.026 2.2C-.186.712.927-.478 1.881.19l20.404 14.135c.953.744.953 2.678 0 3.348z"/>
        </g>
    </svg>
);
